var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"is-vertical",staticStyle:{"flex-shrink":"0"}},[_c('el-main',{staticClass:"login-register"},[_c('div',{staticClass:"headings"},[_c('h2',[_vm._v("Hello!")]),_vm._v(" "),_c('h3',[_vm._v("Sorry, some 404 action here - nothing to see.")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437f1ebf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Page404.vue
// module id = null
// module chunks = 